import { useState } from "react";
import Button from "../utilities/button/Button";
import style from "./ForgetPage.module.css";

function ForgetPage() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [btnStatus, setBtnStatus] = useState(false);

  function EmailHandler(e) {
    setEmail(e.target.value);
  }

  async function SubmitHandler(e) {
    e.preventDefault();
    setStatus("Request is sending Please Wait...");
    setBtnStatus(true);
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/forgetpassword`,
        {
          method: "POST",
          body: JSON.stringify({ email }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (result.status >= 404) {
        setStatus("Invalid Email Address");
        setBtnStatus(false);
      }

      if (result.ok) {
        setStatus("Password Link sent to your Email");
        setBtnStatus(false);
      }
    } catch (err) {
      setStatus(err);
    }
  }

  return (
    <>
      <div className={style.container}>
        <div className={style.box}>
          <form className={style.form} onSubmit={SubmitHandler}>
            <input
              className={style.input}
              type="text"
              value={email}
              onChange={EmailHandler}
              placeholder="Enter Your Email"
            ></input>
            <p
              style={{
                marginBottom: "10px",
                color: `${
                  status === "Password Link sent to your Email"
                    ? "green"
                    : "red"
                }`,
              }}
            >
              {status}
            </p>
            <Button disabled={email.length <= 0 || btnStatus}>
              {btnStatus ? "Wait.." : "Submit"}
            </Button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ForgetPage;
